import { ERROR_EMPTY_TITLE, ERROR_EMPTY_MESSAGE, ERROR_EMPTY_PARTNERS } from "../../../../utils/messages";
import { isNullOrEmpty } from "../../../../utils/common";
import { EMPTY_COUNT } from "../../../../utils/constants";

function validate(payload) {

    let prompt = [];

    if (isNullOrEmpty(payload.title)) {
        prompt.push(ERROR_EMPTY_TITLE);
    }

    if (isNullOrEmpty(payload.message)) {
        prompt.push(ERROR_EMPTY_MESSAGE);
    }

    if (EMPTY_COUNT >= payload.checkedPartners.length) {
        prompt.push(ERROR_EMPTY_PARTNERS);
    }

    return prompt;
}

function isPartnerChecked(partners, currentPartner){
    return partners.some(function(partner){
        return partner.customerCode1 === currentPartner.customerCode1 && partner.customerCode2 === currentPartner.customerCode2;
    }); 
}

export {
    validate,
    isPartnerChecked
};